import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'surveym-survey-sent',
  templateUrl: './survey-sent.component.html',
  styles: []
})
export class SurveySentComponent implements OnInit {

  @Output() onClose = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onCloseAfterSent() {
    this.onClose.emit();
  }

}
